import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      maxWidth: '100%',
    },
    container: {
      width: '100%',
    },
    requiremmentList: {
      marginTop: 15,
    },
    mt: {
      marginTop: 20,
    },
    formContainer: {
      width: '50%',
    },
  };
});

export default useStyles;
